import { SWRConfiguration } from 'swr'

import { ampli } from '@/ampli'
import { fetcher } from '@/utils/fetchers'
import { rg4js } from '@/utils/raygun'

const ERROR_TRACKING_LIMIT = 5
let errorCounter = 0

const swrConfig: SWRConfiguration = {
  fetcher,
  onError: (error, key) => {
    if (
      errorCounter < ERROR_TRACKING_LIMIT &&
      ampli.isLoaded &&
      error?.status > 499
    ) {
      ampli.errorThrown({
        message: error?.message,
        status: error?.status,
        stack: error?.stack,
        swrKey: key,
      })
      errorCounter += 1
    }

    rg4js('send', error)
    console.error(error)
  },
  refreshWhenHidden: false,
  refreshWhenOffline: false,
  revalidateOnFocus: false,
  revalidateOnMount: true,
  revalidateOnReconnect: true,
  shouldRetryOnError: false,
}

export function clearSWRCacheByRegex(cache, regex) {
  // Get all keys from the cache
  const keys = cache.keys()

  // Iterate over all keys
  keys.forEach((key: string) => {
    // Check if the key matches the regex
    if (regex.test(key)) {
      // Delete the cache entry for the key
      cache.delete(key)
    }
  })
}

export default swrConfig
